


























































































































import Vue from 'vue';

import * as ping from '@/lib/usage_ping';
import { Repository } from '@/db/_repo';
const db = new Repository();

import info     from '@/views/app/users/profile-info.vue';
import advanced from '@/views/app/users/profile-advanced.vue';
import soon     from '@/components/coming-soon.vue';
import { UserProfileModel } from '@/models/user'
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
    components: {
        'profile-info': info,
        'profile-advanced': advanced,
        'coming-soon': soon,
    },
    data() {
        return {
            permissionError: false,
            userProfile: null
        }
    },
    methods: {
        ...mapActions([
            "getUserProfile",
            "setUserProfile",
            "updateNotificationPreferences"
        ]),
        updateNotificationPrefs(e) {
            
            let t = event.target as any;
            this.updateNotificationPreferences( { category: t.name, type: t.value, checked: t.checked} ) 
        }
    },
    computed: {
        currentUserProfile: {
            get () {
                // prevents really weird vuex object reference issue with default vue behavior for checkboxes bound to arrays
                return JSON.parse(JSON.stringify(this.$store.state.userProfile)); 
            }
        }
    },
    created() {

        this.getUserProfile(this.currentUser.uid);

        this.sendUsagePing({ type: ping.UserUsage.loadprofile, uid: this.currentUser.uid });
        
        db.users.getProfileDataById(this.currentUser.uid)
        .then((val) => {
            this.userProfile = val;
        })
        .catch((e) => this.toastAndError(this, 'Error fetching user.  Please try again', e));
    }
})
